import type { TableModel } from '../model/table';

export function ResultPanel({ table }: { table: TableModel }) {
  const label = (id: string) => table.seats.find(s => s.id === id)?.label ?? id;
  const result = table.result;
  const showScores = result?.standings.some(s=>s.score!==undefined) ?? false;
  return (
    <section className="panel result" aria-label="Game over" role="status">
      <h2 className="panel-title">Game over</h2>
      {result ? (
        <>
          <p className="result-winners">{result.winners.length === 1 ? `${label(result.winners[0]!)} wins.` : `Winners: ${result.winners.map(label).join(', ')}.`}</p>
          <table className="result-table">
            <thead><tr><th scope="col">Rank</th><th scope="col">Player</th>{showScores && <th scope="col">Score</th>}<th scope="col">Detail</th></tr></thead>
            <tbody>
              {[...result.standings].sort((a, b) => a.rank - b.rank).map(s => (
                <tr key={s.seat} className={result.winners.includes(s.seat) ? 'is-winner' : undefined}>
                  <td>{s.rank}</td><td>{label(s.seat)}</td>{showScores && <td>{s.score}</td>}<td>{s.detail ?? ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="muted">{result.reason}</p>
        </>
      ) : (
        <p className="result-winners">{table.status}</p>
      )}
    </section>
  );
}
